export { ForgeCustomFieldsResolver } from './forge-custom-fields-resolver';
